import { Permission } from '@cims-online/shared'
import { Checkbox } from 'antd'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import CreateEditFormItems from '../../components/CreateEditFormItems'
import { useDispositionTypesContext } from '../../DispositionTypesContext'
import { CreateFormItemsValues } from '../../components/CreateEditFormItems/types'
import { useCreateCasDispositionTypeMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import CIMSFormItem from 'components/CIMSFormItem'
import { CASDispositionType } from '../../DispositionTypesContext/types'
import { HelpMessage } from 'utils/constants'
import { useProjectContext } from 'context/ProjectContext'

export function useCreate(): CreateHeaderActionOptions<CASDispositionType> {
  const { refetch } = useDispositionTypesContext()
  const { projectId } = useProjectContext()
  const [create] = useCreateCasDispositionTypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      createCASDispositionType: {
        dispositionType: { name },
      },
    }) => simpleCreateNotification(name),
  })
  return {
    permission: Permission.CreateCASDispositionType,
    entity: 'Disposition Type',
    modal: {
      type: 'simple',
      body: (
        <>
          <CreateEditFormItems />
          <CIMSFormItem
            name="requiresComments"
            label="Requires Comments"
            valuePropName="checked"
            help={HelpMessage.CAS.DispositionTypes.RequiresComments}
          >
            <Checkbox />
          </CIMSFormItem>
        </>
      ),
      onOk: async ({
        name,
        requiresComments,
        description,
      }: CreateFormItemsValues & { requiresComments?: boolean }) => {
        await create({
          variables: {
            input: { name, projectId, description, requiresComments },
          },
        })
        refetch()
      },
    },
  }
}
